export const MyInvoisDocumentType = {
    INVOICE: "INVOICE",
    CREDIT_NOTE: "CREDIT_NOTE",
    SELF_BILLED_INVOICE: "SELF_BILLED_INVOICE",
    SELF_BILLED_CREDIT_NOTE: "SELF_BILLED_CREDIT_NOTE",
    MINIPOS_ORDER: "MINIPOS_ORDER",
};
